import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, Collapse, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { Colors } from 'theme';

export interface OptionaFunctionInterface {
  icon: JSX.Element;
  title: string;
  onClick: () => void;
}

interface ContainerFormProps {
  title: string;
  subtitle?: string;
  optionaFunction?: OptionaFunctionInterface;
  children: React.ReactNode;
  width?: string;
  onSubmit?: () => void;
}

export const ContainerFormFormik = ({
  title,
  subtitle,
  optionaFunction,
  children,
  width,
  onSubmit,
}: ContainerFormProps): JSX.Element => {
  const [open, setOpen] = useState(true);
  const toggle = () => setOpen(prev => !prev);
  const panelId = title.toLowerCase().replace(/\s+/g, '-');

  return (
    <form onSubmit={onSubmit}>
      <Stack
        sx={
          width
            ? { backgroundColor: Colors.BRANCO_GOV, width: width }
            : { backgroundColor: Colors.BRANCO_GOV }
        }
        marginTop='1rem'
        spacing='1rem'
        padding='1rem'
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          onClick={toggle}
          sx={{ cursor: 'pointer', userSelect: 'none' }}
          aria-controls={`${panelId}-content`}
          aria-expanded={open}
          role="button"
          tabIndex={0}
        >
          <Typography
            variant="h6"
            component="h6"
            fontSize="1.25rem"
            fontWeight="500"
          >
            {title}
          </Typography>

          <Stack direction="row" alignItems="center" spacing={1}>
            {optionaFunction && (
              <Button
                variant="text"
                startIcon={optionaFunction.icon}
                onClick={(e) => { e.stopPropagation(); optionaFunction.onClick(); }}
              >
                {optionaFunction.title}
              </Button>
            )}
            <KeyboardArrowDownIcon
              sx={{
                color: 'text.secondary',
                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
              }}
            />
          </Stack>
        </Stack>

        {subtitle && (
          <Typography variant="body2" mt="0.5rem" color="textSecondary">
            {subtitle}
          </Typography>
        )}

        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box id={`${panelId}-content`}>{children}</Box>
        </Collapse>
      </Stack>
    </form>
  );
}
